var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ejs-treeview',{ref:"moTree",attrs:{"id":"moTree","fields":_vm.fields},on:{"nodeSelected":_vm.moTreeSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }